import "swagger-ui-react/swagger-ui.css"
import Theme from "@hooks/useTheme";
import React from 'react';
import Router from "./pages/Router";
import "@elcimai/webankdesignsystem/dist/style.css";

function App() {
    return (
        <Theme>
                <Router/>
        </Theme>
    )
}

export default App
